import { render, staticRenderFns } from "./add-message.vue?vue&type=template&id=5fe4483e&scoped=true"
import script from "./add-message.vue?vue&type=script&lang=ts"
export * from "./add-message.vue?vue&type=script&lang=ts"
import style0 from "./add-message.vue?vue&type=style&index=0&id=5fe4483e&prod&lang=stylus&module=true"
import style1 from "./add-message.vue?vue&type=style&index=1&id=5fe4483e&prod&lang=stylus&scoped=true"
import style2 from "./add-message.vue?vue&type=style&index=2&id=5fe4483e&prod&lang=less&scoped=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5fe4483e",
  null
  
)

export default component.exports